module.exports = __webpack_public_path__ + "static/media/ic-submi.6a6bbbfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Layout/images/ic-submi.svg
// module id = 1501
// module chunks = 0